export default __webpack_public_path__ + "static/Hi-Phone-9cd1644464b75409c75576e20993465a.png";